// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"89a525a5","889":"3b29e4df","997":"84ec921c"}[chunkId] + ".chunk.js";
};